import { Component, input } from '@angular/core';

import { HolidayNotification } from '../../../../proxy/models/holiday-notification';

@Component({
  selector: 'app-holiday-notification',
  imports: [],
  templateUrl: './holiday-notification.component.html',
  styleUrl: './holiday-notification.component.scss',
})
export class HolidayNotificationComponent {
  public notification = input.required<HolidayNotification>();
}
